<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="pa-2" outlined tile v-if="loading">
          <v-progress-linear  indeterminate color="blue"></v-progress-linear>
        </v-card>
        <v-card class="pa-2" outlined tile v-if="message">
          <v-alert type="error" class="cy-abacus-ticketing-start-error">
            {{ message }}
          </v-alert>
        </v-card>
        <v-card class="pa-2" outlined tile v-if="startProcessResponse">
          <v-alert type="success" class="cy-abacus-ticketing-start-success">
            {{ $t('abacus.ticketing.start.success') }}
          </v-alert>
          <p><router-link class="cy-ticket-link" :to="{ name: TICKETING_PROCESS_DETAILS, params: { processInstanceId: startProcessResponse.ticketId}}">{{ $t('abacus.ticketing.common.openTicket') }}</router-link></p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TICKETING_PROCESS_DETAILS } from '@/config/options/routes/ticketingRoutes'
import { START_PROCESS } from '../graphql-apollo/abacusTicketing.gql.js'

export default {
  name: 'AbacusTicketingStart',
  data () {
    return {
      startProcessResponse: null,
      message: '',
      loading: false,
      TICKETING_PROCESS_DETAILS: TICKETING_PROCESS_DETAILS
    }
  },
  created () {
    this.startProcess()
  },
  computed: {
    processDefinitionKey () {
      return this.$route.params.processDefinitionKey
    },
    externalTicketId () {
      return this.$route.params.externalTicketId
    }
  },
  methods: {
    startProcess () {
      this.message = null
      if (!this.processDefinitionKey) {
        this.message = this.$t('abacus.ticketing.common.missingInput') + 'processDefinitionKey'
      } else if (!this.externalTicketId) {
        this.message = this.$t('abacus.ticketing.common.missingInput') + 'externalTicketId'
      } else {
        this.startProcessResponse = null
        this.loading = true
        this.$apollo.mutate({
          mutation: START_PROCESS,
          variables: {
            processDefinitionKey: this.processDefinitionKey,
            externalTicketId: this.externalTicketId
          }
        }).then((response) => {
          this.startProcessResponse = response.data.startProcessForExternalTicketId
          this.loading = false
        }).catch((error) => {
          if (error.toString().includes("TerminationRelettingProcessExists")) {
            this.message = this.$t('abacus.ticketing.start.ticketAlreadyExists')
          } else {
            this.message = this.message = this.$t('abacus.ticketing.start.failure') + error
          }
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped lang="postcss">
</style>
